import React, { useState, useEffect } from "react";
import { Table, Tag, Tooltip, Spin, Select, Input, Switch, Card } from "antd";
import { getAtomizerData, getEmailIntegration, getInlineImage, getTicketData, updateEmailAccess } from "../../API/api";
import { momentit } from "../../utils";
// import ReactMarkdown from 'react-markdown';
import { MoreOutlined } from "@ant-design/icons";
import {
  SearchOutlined,
  SyncOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import OptionMenu from "./OptionMenu";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import MultiSelectCmTwo from "../MultiSelectCmTwo/MultiSelectCmTwo";
import { ingestTypeObj } from "../../Constants";
import moment from "moment/moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ThreeDotMenu from "./emailOptionMenu";
import { openPreviewAttachment } from "../AttachmentBox/AttachmentBox";
import Styles from './cssStyles.module.css'
import { toast } from "react-toastify";
import TabSearch from "../../NewComponent/TabSearch/tabSearch";
import { TagCompDomain } from "../ExpertRecordsDetail/QuestionBox";
// import PdfIcon from '../../Icons/pdfDark.svg'
// import svgVideo from '../../Icons/videoDark.svg'
// import ImgVideo from '../../../Icons/imageDark.svg'
// import threadIcon from '../../Icons/newThread.svg'
// import crawIcon from '../../Icons/crawl.svg'
import PdfIcon from '../../Icons/pdfDark.svg'
import svgVideo from '../../Icons/videoDark.svg';
import ImgVideo from '../../Icons/imageDark.svg';
import threadIcon from '../../Icons/newThread.svg';
import crawIcon from '../../Icons/crawl.svg'
function loweFirstLetter(string) {
  return string?.charAt(0)?.toLowerCase() + string?.slice(1);
}

const containerStyles = {
  borderColor: '#E0E2E6',
  boxShadow: '0px 1px 2px 0px #1018280D',
  color: '#5C667B !important',
  zIndex: '0',
  width: "100%"
}
const formatEmailBody = (text) => {
  // Replace "VIZSEP" with double newlines for paragraph separation
  if (text !== undefined || null) {
    let formattedText = text?.replace(/VIZSEP/g, '\n\n');

    // Replace underscores with a horizontal line
    formattedText = formattedText.replace(/_{2,}/g, '<hr />');

    // Convert numbered items like "1.", "2." to list items
    formattedText = formattedText.replace(/(\d+\.)\s/g, '\n$1 ');  // Ensure each numbered item starts on a new line
    const paragraphs = formattedText?.split(/\n\n+/).map((paragraph) => {
      // Check if the paragraph contains a numbered list
      if (/^\d+\.\s/.test(paragraph)) {
        // Split by lines starting with numbered items and wrap each in <li>
        const listItems = paragraph.split(/\n/).map(
          line => line.trim().match(/^\d+\.\s/) ? `<li>${line.trim()}</li>` : line
        ).join('');
        return `<ul>${listItems}</ul>`;
      }
      // For regular paragraphs, replace newlines with <br />
      return `<p style='padding-inline:14px;'>${paragraph.replace(/\n/g, '<br />')}</p>`;
    });

    return paragraphs?.join('');
  }
  return;

};
const successfulHelpful = (message) => {
  return (
    <>
      <span style={{ fontSize: "12px" }}>{message}</span>
    </>
  );
};


const filtering = (row, text) => {
  return (
    row &&
    row?.filter((row) =>
      Object.values(row)?.some((value) =>
        value?.toString().toLowerCase().includes(text.toLowerCase())
      )
    )
  );
}
export const renderUrl = (url) => {
  return (
    <div style={{ textAlign: "start" }}>
      <a
        style={{ fontWeight: "300", fontSize: "12px" }}
        href={url}
        target="_blank"
      >
        {url}
      </a>
    </div>
  );
};
const readableDate = (date) => moment(date).format('MMM D, YYYY');

export default function JobsTable() {
  const [filterValue, setFilterValue] = useState("nameDesc");
  const [count, setCount] = useState(null);
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [rows, setRowData] = React.useState([]);
  const [origRows, setOrigRowData] = React.useState([]);
  const [emailData, setEmailData] = React.useState([]);
  const [qaPair, setQaPair] = React.useState(false)
  const [tickedId, setTicketId] = React.useState(null);
  const [ticketData, setTicketData] = React.useState([]);
  const [emailBody, setEmailBody] = React.useState(null);
  const drawerState = useSelector((state) => state.drawer);
  const [doctype, setDoctype] = React.useState({
    label: "Pdf",
    value: "Pdf",
    name: "Pdf",
  });
  const [emailName, setEmailName] = React.useState(null);
  // const drawerState = useSelector((state) => state.drawer);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [tabSearch, settabSearch] = useState("");
  const [isRefreshing, setRefreshing] = useState(false);

  const state = useSelector((state) => state.drawer);


  const convertHtmlToPDF = (resp) => {
    if (resp !== null && resp !== undefined && resp !== '') {
      let payload = [`${resp}`];
      // openPreviewAttachment(resp)
      getInlineImage(payload).then((res) => {
        window.open(res.data.data[`${resp}`], '_blank');
      })
    } else {
      toast.error(successfulHelpful("File does not exist!"), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  }


  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });

  const dispatch = useDispatch();
  const { ingestedSelectedData, advanceFilterModalToggle, getUpdatedSpinner, zIndexFooterLoaderAction } = bindActionCreators(
    Actions,
    dispatch
  );
  const onChangeDocType = (val) => {
    // console.log("val", val)
    setDoctype(val);
  };
  const onClickOptions = () => {
    fetchData();
  };
  const onChangeFilterStr = (str) => {
    settabSearch(str);

    // console.log("str", str)
    if (str === "") {
      setRowData(origRows);
    } else {
      let filteredData = origRows.filter((obj) => {
        if (obj.jobid.toLowerCase().includes(str.toLowerCase())) {
          return obj;
        }
      });
      setRowData(filteredData);
    }
  };
  const renderTitle = (title, position = "center") => {
    return (
      <div style={{ textAlign: position }}>
        <span style={{ fontWeight: "500", fontSize: "17px" }}>{title}</span>
      </div>
    );
  };
  const renderPara = (title, position) => {
    return (
      <div style={{ textAlign: position }}>
        <span style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
        }}>{title}</span>
      </div>
    );
  };

  const renderDomain = (domains) => {
    if (domains === undefined) {
      return "";
    }
    const renderDomains = () => {
      return (
        <>
          {domains === undefined
            ? ""
            : domains.map((domain) => {
              return (
                <Tag
                  // color="var(--light_color_shade)"
                  style={{
                    fontSize: "10px",
                    backgroundImage: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                    color: "#fff", // ensure text is readable
                    border: "none"
                  }}
                >
                  {domain}
                </Tag>
                // <Tag
                // color="var(--light_color_shade)"
                // style={{
                //   fontSize: "11px",
                //   backgroundImage: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                //   border: "none",
                //   color: "#fff",
                //   borderRadius: "4px",
                //   padding: "0 8px",
                //   height: "20px",          // match AntD default Tag height
                //   display: "inline-flex",
                //   alignItems: "center",    // vertical-center text
                //   whiteSpace: "nowrap",
                // }}
                // >
                //   {domain}
                // </Tag>
                // <TagCompDomain key={domain} title={domain} />
              );
            })}
        </>
      );
    };
    return (
      <div style={{ textAlign: "center" }}>
        {domains !== undefined && domains.length === 0 ? (
          <Tag></Tag>
        ) : (
          <span
            style={{ fontWeight: "300", fontSize: "11px", cursor: "pointer" }}
          >
            <Tooltip
              title={renderDomains()}
              color="#f0f0f0"
              style={{ color: "black" }}
            >
              <Tag
                color="var(--light_color_shade)"
                style={{
                  fontSize: "11px",
                  backgroundImage: "linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
                  border: "none",
                  color: "#fff",
                  borderRadius: "4px",
                  padding: "0 8px",
                  height: "20px",          // match AntD default Tag height
                  display: "inline-flex",
                  alignItems: "center",    // vertical-center text
                  whiteSpace: "nowrap",
                }}
              >
                {domains[0]}
              </Tag>
            </Tooltip>
            <span
              style={{ fontSize: "10px", display: "block", color: "#808080" }}
            >
              {domains !== undefined && domains.length > 1
                ? `+${domains.length - 1} more`
                : ""}
            </span>
          </span>
        )}{" "}
      </div>
    );
  };
  const renderActionButton = (title) => {
    return (
      <div style={{ textAlign: "center" }}>
        <span style={{ fontWeight: "300", fontSize: "18px" }}>
          <MoreOutlined />
        </span>
      </div>
    );
  };
  // console.log("first",pageNo)
  const renderStatus = (data) => {
    return (
      <div style={{ textAlign: "center" }}>
        <span style={{ fontWeight: "300", fontSize: "12px" }}>
          {/* <Tag
            style={{
              fontSize: "12px", background: data.indexed
                ? "linear-gradient(90deg, #21b384, #4ef1c3)"
                : "linear-gradient(90deg, #f7851f, #f9a53f)",
              color: "#FFFFFF"
            }}
          // color={data.indexed ? "#21b384" : "#f7851f"}

          >
            {data.indexed ? "Published" : "Not Published"}
          </Tag> */}
          <Tag
            style={{
              fontSize: "12px",
              background: data.indexed
                ? "linear-gradient(90deg,rgb(17, 184, 128), #35c99d)"   // darker green
                : "linear-gradient(90.39deg, rgb(255, 152, 0) 0.34%, rgb(251, 140, 0) 99.7%)", // darker orange
              color: "white",
              border: "none",
            }}
          >
            {data.indexed ? "Published" : "Not Published"}
          </Tag>
          {data.indexed && data.usageAccess === "internal" && (
            <i style={{ color: "grey" }} class="fa fa-user-times"></i>
          )}
          {data.newSoId !== null && (
            <span
              style={{
                display: "block",
                fontSize: "10px",
                fontWeight: "block",
              }}
            >
              New Version available
            </span>
          )}
        </span>
      </div>
    );
  };
  const filterData = (data) => {
    let newData = [];
    let nos = 1;
    for (let key in data) {
      if (data[key].length === 1) {
        let newObj = data[key][0];
        newObj.jobid = key;
        newObj.id = nos;
        newData.push(newObj);
        ++nos;
      }
      if (data[key].length > 1) {
        data[key].filter((nd, index) => {
          let newObj = nd;
          newObj.jobid = `${key}(${index})`;
          newObj.id = nos;
          newData.push(newObj);
          ++nos;
        });
      }
    }

    setRowData(newData);
    setOrigRowData(newData);
    setLoading(false);
    setRefreshing(false);
  };
  const refreshData = () => {
    if (!isRefreshing) {
      setRefreshing(true);
      fetchData();
    }
    if (!isRefreshing && doctype.value === "emailIntegration") {
      setRefreshing(true);
      fetchEmailData(pageNo);
    }
  };


  const fetchEmailData = (page) => {
    settabSearch("");
    setSelectedRowKeys([]);
    setLoading(true);
    setRowData([]);
    setOrigRowData([]);
    getEmailIntegration(page).then((res) => {
      if (res === undefined) return;
      setCount(res.data.count)
      //  console.log("response",res)
      setEmailData(res.data.data);

      setLoading(false);
      setRefreshing(false);
    });
  }

  const fetchData = () => {
    settabSearch("");
    setSelectedRowKeys([]);
    setLoading(true);
    setRowData([]);
    setOrigRowData([]);
    if (doctype.value !== "emailIntegration") {
      getAtomizerData(doctype.value).then((res) => {
        if (res === undefined) return;
        setTableParams({
          pagination: {
            current: 1,
            pageSize: 10,
          },
        });
        filterData(res.data.data);
      });
    }

  };
  const onSelectChange = (newSelectedRowKeys) => {
    // console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const onChangeAccess = (ticketUuidStr, usageAccess) => {
    // console.log("usage", usageAccess==="false"?true:false)
    setLoading(true);
    const usage = usageAccess === "internal" || usageAccess === "private" || usageAccess === "true" ? "public" : usageAccess === "public" || usageAccess === "false" || usageAccess === null ? "internal" : ""; // Toggle the current usageAccess value

    updateEmailAccess(ticketUuidStr, usage).then((res) => {
      if (res !== undefined) {
        fetchEmailData(pageNo);
        setLoading(false)
      }
    });
  };

  const onClickEmail = (ticketId) => {
    setLoading(true)
    setTicketId(ticketId)
    getTicketData(ticketId).then((res) => {

      settabSearch("");
      setSelectedRowKeys([]);
      if (res === undefined) return;
      setEmailBody(res.data.data)
      setTicketData(res.data.data);
      setLoading(false)
    })
  }



  const columns = [
    {
      title: renderTitle("JobID", "start"),
      dataIndex: "jobid",
      sorter: (a, b) => a.jobid.localeCompare(b.jobid),
      width: "15%",
      render: (_, row) => (
        <span
          // style={{ wordBreak: 'break-word',overflowWrap: 'break-word', }}
          style={{
            fontSize: "13px",
            color: "#2A364A",
            fontWeight: "500",
          }}
        >
          {renderPara(row.jobid, "start")}
        </span>
      ),
    },
    {
      title: renderTitle("Date", "start"),
      dataIndex: "dateParsed",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.dateParsed - b.dateParsed,
      // render:(_,row)=>console.log("row?.url ",row)
      render: (_, row) => (
        <>
          <span
            style={{
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
            }}
          >{renderPara(momentit(row.dateParsed))}</span>
        </>
      ),
    },
    {
      title: renderTitle("Title/URL", "start"),
      dataIndex: "title",
      width: "29.5%",
      render: (_, row) => {
        const lowerTitle = row.title?.toLowerCase() || "";
        const lowerSource = row.source?.toLowerCase() || "";
        const lowerDocType = row.docType?.toLowerCase() || "";

        const isAttachment = lowerTitle.endsWith(".pdf");
        const isImage = [".jpg", ".jpeg", ".png"].some(ext =>
          lowerTitle.endsWith(ext)
        );

        return (
          <span
            className={isAttachment || isImage ? Styles.jobtitle : ""}
            style={{
              wordBreak: "break-word",
              fontSize: "13px",
              color: "#2A364A",
              fontWeight: "500",
              overflowWrap: "break-word",
              cursor: isAttachment || isImage ? "pointer" : "auto"
            }}
            // style={{
            //   fontSize: "13px",
            //   color: "#2A364A",
            //   fontWeight: "500",
            //   display: "flex",
            //   width: "50%",
            //   justifyContent: "flex-end",
            //   textAlign: "right",
            // }}
            onClick={() => {
              // 🚫 Skip click if source is "url" or docType is "pdf native"
              if (lowerSource === "url" || lowerDocType === "pdf native") return;

              if (row?.source === "pdf" && row?.docType === "Pdf") {
                // console.log("PDF clicked", row);
                convertHtmlToPDF(row?.title);
                return;
              }

              if (row?.source === "image" && row?.docType === "Image") {
                // console.log("Image clicked", row);
                openPreviewAttachment(row?.title);
                return;
              }
            }}
          >
            {row.url === null && renderPara(row.title)}
            {row.url !== null && renderUrl(row.url)}
          </span>
        );
      }
    }
    ,
    {
      title: renderTitle("Source"),
      dataIndex: "source",
      width: "7.5%",
      render: (_, row) => (
        <div style={{ textAlign: "center" }}>
          <Tooltip
            color="#fff"
            title={() => (
              <span style={{ color: "black", textTransform: "capitalize" }}>
                {row.source}
              </span>
            )}
          >
            {row.source === "pdf" || row.source === "pdf native" || row.source === "multiple" ? (

              <img
                width="47px"
                height="23px"
                src={PdfIcon}
                alt="pdf"
              />
            ) : row.source === "video" ? (

              <img
                width="20"
                height="20"
                src={svgVideo}
                alt="video"
              />

            ) : row.source === "image" ? (
              <img
                width="20"
                height="20"
                src={ImgVideo}
                alt="image"
              />
            ) : row.source === "crawled" ? (
              <img
                width="20"
                height="20"
                src={crawIcon}
                alt="url"
                style={{
                  filter: "grayscale(100%) brightness(0.3)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : row.source === "Thread" ? (
              <img
                width="20"
                height="20"
                src={threadIcon}
                alt="thread"
                style={{
                  filter: "grayscale(100%) brightness(0.5)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : row.source === "url" ? (
              <img
                width="20"
                height="20"
                src={threadIcon}
                alt="thread"
                style={{
                  filter: "grayscale(100%) brightness(0.5)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : (
              "-"
            )}
          </Tooltip>
          {/* <Tooltip
            color="#f0f0f0"
            title={() => {
              return (
                <span style={{
                  fontSize: "13px",
                  color: "#2A364A",
                  fontWeight: "500",
                  // color: "black", textTransform: "capitalize" 
                }}>
                  {row.source}
                </span>
              );
            }}
          >
            {(row.source === "pdf" || row.source === "pdf native") && (
              <span>
                <img
                  width="20"
                  height="20"
                  src={require("../../Images/pdf.png")}
                />
              </span>
            )}
            {row.source === "multiple" && (
              <span>
                <img
                  width="20"
                  height="20"
                  src={require("../../Images/documents.png")}
                />
              </span>
            )}
            {row.source === "Thread" && (
              <span>
                <img
                  width="20"
                  height="20"
                  src={require("../../Images/Thread.png")}
                />
              </span>
            )}
            {row.source === "url" && (
              <span>
                <img
                  width="20"
                  height="20"
                  src={require("../../Images/newUrl.png")}
                />
              </span>
            )}
            {row.source === "image" && (
              <span>
                <img
                  width="20"
                  height="20"
                  src={require("../../Images/newImage.png")}
                />
              </span>
            )}
            {row.source === "video" && (
              <span>
                <img
                  width="20"
                  height="20"
                  src={require("../../Images/newVideoIcon.png")}
                />
              </span>
            )}
          </Tooltip> */}
        </div>
      ),
    },
    {
      title: renderTitle("Domains"),
      dataIndex: "indexed",
      width: "20%",
      render: (_, row) => <span>{renderDomain(row.domains)}</span>,
    },
    {
      title: renderTitle("Status"),
      dataIndex: "indexed",
      width: "12%",
      sorter: (a, b) => a.indexed - b.indexed,
      render: (_, render) => (
        <>
          <span>{renderStatus(render)}</span>
        </>
      ),
    },
    {
      title: " ",
      dataIndex: "source",
      width: "1%",
      render: (_, render) => (
        <>
          <OptionMenu data={render} onChanges={onClickOptions} />
        </>
      ),
    },
  ];

  const ThreadColumns = [
    {
      title: renderTitle("JobID", "start"),
      dataIndex: "jobid",
      sorter: (a, b) => a.jobid.localeCompare(b.jobid),
      width: "15%",
      render: (_, row) => (
        <span style={{ wordBreak: 'break-word', overflowWrap: 'break-word', }}>
          {renderPara(row.jobid, "start")}
        </span>
      ),
    },
    {
      title: renderTitle("Channel Name", "start"),
      dataIndex: "ChannelName",
      sorter: (a, b) => a?.channelName?.localeCompare(b?.channelName),
      width: "29.5%",
      defaultSortOrder: "descend",
      render: (_, row) => (
        <span style={{ wordBreak: 'break-word', overflowWrap: 'break-word', }}>
          {renderPara(row?.channelName, "start")}
          {/* {row.url === null && renderPara(row.title)}
          {row.url !== null && renderUrl(row.url)} */}
        </span>
      ),
    },
    {
      title: renderTitle("Date (From)", "start"),
      dataIndex: "fromDate",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.fromDate - b.fromDate,
      render: (_, row) => (
        <>
          <span>{renderPara(momentit(row.fromDate, "start"))}</span>
        </>
      ),
    },

    {
      title: renderTitle("Date (To)", "start"),
      dataIndex: "toDate",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.toDate - b.toDate,
      render: (_, row) => (
        <>
          <span>{renderPara(momentit(row.toDate, "start"))}</span>
        </>
      ),
    },
    {
      title: renderTitle("Date (Ingested)", "start"),
      dataIndex: "dateParsed",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.dateParsed - b.dateParsed,
      render: (_, row) => (
        <>
          <span>{renderPara(momentit(row.dateParsed, "start"))}</span>
        </>
      ),
    },

    {
      title: renderTitle("Source"),
      dataIndex: "source",
      width: "7.5%",
      render: (_, row) => (
        <div style={{ textAlign: "center" }}>
          <Tooltip
            color="#fff"
            title={() => (
              <span style={{ color: "black", textTransform: "capitalize" }}>
                {row.source}
              </span>
            )}
          >
            {row.source === "pdf" || row.source === "pdf native" || row.source === "multiple" ? (

              <img
                width="47px"
                height="23px"
                src={PdfIcon}
                alt="pdf"
              />
            ) : row.source === "video" ? (

              <img
                width="20"
                height="20"
                src={svgVideo}
                alt="video"
              />

            ) : row.source === "image" ? (
              <img
                width="20"
                height="20"
                src={ImgVideo}
                alt="image"
              />
            ) : row.source === "crawled" ? (
              <img
                width="20"
                height="20"
                src={crawIcon}
                alt="url"
                style={{
                  filter: "grayscale(100%) brightness(0.3)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : row.source === "Thread" ? (
              <img
                width="20"
                height="20"
                src={threadIcon}
                alt="thread"
                style={{
                  filter: "grayscale(100%) brightness(0.5)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : row.source === "url" ? (
              <img
                width="20"
                height="20"
                src={threadIcon}
                alt="thread"
                style={{
                  filter: "grayscale(100%) brightness(0.5)", // Makes it gray and dimmer
                  opacity: 0.6, // Slight transparency like the video icon
                }}
              />
            ) : (
              "-"
            )}
          </Tooltip>
          {/* <Tooltip
    color="#f0f0f0"
    title={() => {
      return (
        <span style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
          // color: "black", textTransform: "capitalize" 
        }}>
          {row.source}
        </span>
      );
    }}
  >
    {(row.source === "pdf" || row.source === "pdf native") && (
      <span>
        <img
          width="20"
          height="20"
          src={require("../../Images/pdf.png")}
        />
      </span>
    )}
    {row.source === "multiple" && (
      <span>
        <img
          width="20"
          height="20"
          src={require("../../Images/documents.png")}
        />
      </span>
    )}
    {row.source === "Thread" && (
      <span>
        <img
          width="20"
          height="20"
          src={require("../../Images/Thread.png")}
        />
      </span>
    )}
    {row.source === "url" && (
      <span>
        <img
          width="20"
          height="20"
          src={require("../../Images/newUrl.png")}
        />
      </span>
    )}
    {row.source === "image" && (
      <span>
        <img
          width="20"
          height="20"
          src={require("../../Images/newImage.png")}
        />
      </span>
    )}
    {row.source === "video" && (
      <span>
        <img
          width="20"
          height="20"
          src={require("../../Images/newVideoIcon.png")}
        />
      </span>
    )}
  </Tooltip> */}
        </div>
      ),
    },
    {
      title: renderTitle("Status", "start"),
      dataIndex: "indexed",
      width: "12%",
      sorter: (a, b) => a.indexed - b.indexed,
      render: (_, render) => (
        <>
          <span>{renderStatus(render, "start")}</span>
        </>
      ),
    },
    {
      title: " ",
      dataIndex: "source",
      width: "1%",
      render: (_, render) => (
        <>
          <OptionMenu data={render} onChanges={onClickOptions} />
        </>
      ),
    },
  ];
  const QaPairColumn = [
    // {
    //   title: renderTitle("Id", "start"),
    //   dataIndex: 'id',
    //   sorter: (a, b) => a?.id-b?.id,
    //   width: "2%",
    //   render: (_, row) => (
    //     <span style={{ wordBreak: "break-all" }}>
    //       {renderPara(row.id, "start")}
    //     </span>
    //   ),
    // },
    {
      title: renderTitle("Question", "start"),
      dataIndex: 'question',
      sorter: (a, b) => a?.question.localeCompare(b?.question),
      width: "15%",
      render: (_, row) => (
        <span style={{ wordBreak: 'break-word', overflowWrap: 'break-word', }}>
          {renderPara(row.question, "start")}
        </span>
      ),
    },
    {
      title: renderTitle("Answer", "start"),
      dataIndex: 'answer',
      sorter: (a, b) => a?.answer.localeCompare(b?.answer),
      width: "25%",
      render: (_, row) => (
        <span style={{ wordBreak: 'break-word', overflowWrap: 'break-word', }}>
          {renderPara(row.answer, "start")}
        </span>
      ),
    },
    {
      title: " ",
      dataIndex: "source",
      width: "1%",
      render: (_, row) => (
        <>
          <ThreeDotMenu question={row.question} answer={row.answer} emailId={row?.id} setLoading={setLoading} published={row.indexed} onClickEmail={onClickEmail} tickedId={tickedId} />
        </>
      ),
    },


  ]

  const EmailColumn = [

    {
      title: renderTitle("Subject", "start"),
      dataIndex: "subject",
      sorter: (a, b) => a?.subject.localeCompare(b?.subject),
      width: "35%",
      render: (_, row) => (
        <span style={{
          fontSize: "13px",
          fontWeight: "300",
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
          color: "#0D6EFD",
          textDecoration: "underline",
          textAlign: "start"
        }} onClick={() => {

          onClickEmail(row?.ticketUuidStr)

          setEmailName(row.subject)
          // zIndexFooterLoaderAction(true)
          setQaPair(true);

        }}>
          {row.subject}
        </span>
      ),
    },
    {
      title: renderTitle("Date", "start"),
      dataIndex: "lastEmailDate",
      width: "15%",
      defaultSortOrder: "descend",
      sorter: (a, b) => new Date(a?.lastEmailDate) - new Date(b?.lastEmailDate),
      render: (_, row) => (
        <>
          <span>{renderPara(readableDate(row?.lastEmailDate))}</span>
        </>
      ),
    },
    {
      title: renderTitle("QA Pair", "start"),
      dataIndex: "qaPairCount",
      width: "10%",
      defaultSortOrder: "descend",
      sorter: (a, b) => a?.qaPairCount - b?.qaPairCount,

      render: (_, row) => (
        <>
          <span style={{ display: 'flex', justifyContent: "center" }}>{renderPara(row?.qaPairCount)}</span>
        </>
      ),
    },
    // },
    {
      title: renderTitle("Visibility"),
      align: "center",
      dataIndex: "title",
      width: "20%",
      // sorter: (a, b) => a.filtered - b.filtered,
      render: (_, row) => (
        <div
          style={{
            wordBreak: 'break-word', overflowWrap: 'break-word',
            fontSize: "15px",
            fontWeight: "300",
            textAlign: "center",
          }}
        >
          <Tag color={`${row.usageAccess === "internal" || row.usageAccess === "true" || row.usageAccess === "private" ? "red" : row.usageAccess === "public" || row.usageAccess === null || row.usageAccess === "false" ? "green" : ""}`}>
            {row.usageAccess === "internal" || row.usageAccess === "true" || row.usageAccess === "private" ? "Internal" : row.usageAccess === "public" || row.usageAccess === null || row.usageAccess === "false" ? "Public" : ""}
          </Tag>
        </div>
      ),
    },
    {
      title: renderTitle("", "center"),
      alignItem: "center",
      dataIndex: "title",
      width: "5%",
      render: (_, row) => (
        <div
          style={{
            wordBreak: 'break-word', overflowWrap: 'break-word',
            fontSize: "15px",
            fontWeight: "30",
            textAlign: "center",
          }}
        >
          <Switch
            checked={row.usageAccess === "public" || row.usageAccess === null || row.usageAccess === "false"}  // Only true if usageAccess is true
            size="small"
            onClick={() => onChangeAccess(row?.ticketUuidStr, row.usageAccess)}
          />
        </div>
      ),
    },


  ]


  const handleChange = (pagination, filters, sorter, extra) => {
    // console.log("params", pagination);
    const { field, order } = sorter;
    if (field !== undefined && order !== undefined) {
      const value = `${loweFirstLetter(field)}${order === "ascend" ? "asc" : "Desc"
        }`;
      setFilterValue(value);
    }
  };
  const onChange = (pagination, filters, sorter, extra) => {
    setTableParams({ pagination: { pagination } });
  };
  const tooltipTitle = (str) => {
    return <span style={{ color: "black" }}>{str}</span>;
  };
  const openModalMultiOpen = (key) => {
    ingestedSelectedData(selectedRowKeys);
    if (key === "delete") {
      advanceFilterModalToggle({ bool: true, value: "deleteMultiDoc" });
    }
    if (key === "publish") {
      advanceFilterModalToggle({ bool: true, value: "publishMultiDoc" });
    }
    if (key === "unpublish") {
      advanceFilterModalToggle({ bool: true, value: "unpublishMultiDoc" });
    }
  };

  useEffect(() => {
    settabSearch("")
    if (doctype.value !== "emailIntegration") {
      fetchData();
    }
    if (doctype.value === "emailIntegration") {
      fetchEmailData(pageNo);

    }
    if (doctype.value === "emailIntegration" && qaPair) {
      setLoading(true);
      onClickEmail(tickedId)
    }

  }, [doctype, state.refresh, pageNo]);
  useEffect(() => {
    onChangeFilterStr("")
    settabSearch("")
  }, [state.refreshState])
  useEffect(() => {
    setPageNo(0);
    setPageSize(10);
  }, [qaPair, doctype.value]);


  useEffect(() => {
    settabSearch("")
    if (drawerState.updateSpinner) {
      setLoading(true);
      onClickEmail(tickedId);
      getUpdatedSpinner(false)
    }
  }, [drawerState?.updateSpinner]);

  console.log("qaPair", filtering(qaPair ? ticketData?.qaPairs : emailData, tabSearch))
  console.log("count", count)

  const getColumns = () => {
    if (doctype.value === "Thread") return ThreadColumns;
    if (doctype.value === "emailIntegration") {
      return qaPair ? QaPairColumn : EmailColumn;
    }
    return columns;
  };

  const getDataSource = () => {
    if (doctype.value === "emailIntegration") {
      return qaPair ? filtering(ticketData?.qaPairs, tabSearch) : filtering(emailData, tabSearch);
    }
    return rows;
  };

  return (
    <div style={{ width: "100%", margin: "auto" }}>
      <div>
        {
          doctype.value === "emailIntegration" && qaPair && <ArrowBackIcon style={{ cursor: "pointer" }} onClick={() => {
            setQaPair(false);

            fetchEmailData(pageNo)
          }} />
        }


      </div>
      <div
        className="mb-2 mt-2"
        style={{
          display: "flex",
          boxShadow: "7px 7px 20px lightgrey",
          backgroundColor: "#FAFAFA",
          justifyContent: "space-between",
          border: "1px solid #FAFAFA",
          alignItems: "center",
          borderRadius: "6px",
          padding: "8px",
        }}
      >
        <div style={{ display: "flex", alignItems: "baseline", width: "50%" }}>

          <span style={{ width: "30%" }}>
            {/* <TabSearch width={'100%'} size="medium" value={tabSearch} onChangeFunc={(e) => onChangeFilterStr(e.target.value)} />
             */}
            <Input
              allowClear
              style={containerStyles}
              value={tabSearch}
              prefix={<SearchOutlined style={{ color: '#ACB6C6' }} />}
              onChange={(val) => onChangeFilterStr(val.target.value)}
              placeholder={doctype.value === "emailIntegration" && qaPair ? "Search for a QA Pair..." : doctype.value === "emailIntegration" && !qaPair ? "Search for an email..." : `Search for a job...`}
            />
          </span>
          &nbsp;

          <span style={{ marginTop: "9.5px", zIndex: "10", width: "30%" }}>
            {/* <MultiSelectCmTwo
              onChangeFunc={onChangeDocType}
              value={doctype}
              options={ingestTypeObj}
            /> */}
            <Select
              labelInValue
              options={ingestTypeObj}
              value={doctype}
              // defaultValue={{ label: 'All', value: null }}
              onChange={onChangeDocType}
              placeholder="Select "
              //  popupClassName={Styles.searchSuggestionCss}
              size="middle"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }
              }
              dropdownStyle={{ zIndex: 1 }}
            />
            {/* <Select
                      labelInValue
                      options={options} 
                      value={selectedExpert}
                      // defaultValue={{ label: 'All', value: null }}
                      onChange={onChangeSelectedOption} 
                      // defaultvalue={domains}
                      placeholder="Select Expert"
                      popupClassName={Styles.selectCss}
                      size="middle"
                      showSearch
                      filterOption={(input, option) =>
                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                      }
                      style={{ width: "100%", border: 'none', boxShadow: '0px 1px 2px 0px #1018280D', fontSize: '16px' }}
                    // size={"medium"}
                    // width={"100px"}
                    /> */}
          </span>
        </div>
        <div>
          {selectedRowKeys.length > 0 && (
            <span>
              <Tooltip title={tooltipTitle("Unpublish")} color="#fafafa">
                {/* <i
                className="fa fa-envelope-open"
                style={{ color: "#5c667b" }}
              ></i> */}
                <i
                  className="fa fa-envelope-open-o"
                  onClick={() => openModalMultiOpen("unpublish")}
                  style={{ fontSize: "20px", cursor: "pointer", color: "#5c667b" }}
                ></i>
              </Tooltip>
              &nbsp;&nbsp;
              <Tooltip title={tooltipTitle("Publish")} color="#fafafa">
                <i
                  className="fa fa-envelope"
                  onClick={() => openModalMultiOpen("publish")}
                  style={{ fontSize: "20px", cursor: "pointer", color: "#5c667b" }}
                ></i>
              </Tooltip>
              &nbsp;&nbsp;
              <Tooltip title={tooltipTitle("Delete")} color="#fafafa">
                <i
                  className="fa fa-trash"
                  onClick={() => openModalMultiOpen("delete")}
                  style={{ fontSize: "20px", cursor: "pointer", color: "#5c667b" }}
                ></i>
              </Tooltip>
            </span>
          )}
          {selectedRowKeys.length === 0 && (
            <span>
              <Tooltip title={tooltipTitle("Refresh List")} color="#fafafa">
                <SyncOutlined
                  colSpan={3}
                  span={2}
                  onClick={() => refreshData()}
                  spin={isRefreshing}
                  style={{ fontSize: "16px" }}
                />
              </Tooltip>
            </span>
          )}
        </div>
      </div>

      {doctype.value === "emailIntegration" && qaPair && ticketData?.cleanEmailBody !== null ? (
        <Spin spinning={isLoading}>
          <div
            className="mb-2 mt-2"
            style={{
              display: "flex",
              boxShadow: "7px 7px 20px lightgrey",
              backgroundColor: "#FAFAFA",
              justifyContent: "space-between",
              border: "1px solid #FAFAFA",
              alignItems: "flex-start",
              borderRadius: "6px",
              padding: "8px",
            }}
          >
            <Card
              title={`Email: ${emailName}`}
              style={{
                width: '100%'
              }}
              className="email-card"
            // className={}
            >
              <div
                dangerouslySetInnerHTML={{ __html: formatEmailBody(ticketData?.cleanEmailBody) }}
              />
            </Card>
          </div>
        </Spin>
      ) : (
        <></>
      )}

{/* <Spin spinning={isLoading}>
       
       {
         doctype.value === "emailIntegration"&&!qaPair ?  <Table
         showSorterTooltip={false}
         rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
         columns={EmailColumn}
         dataSource={
           doctype.value === "emailIntegration" ? filtering(qaPair ? ticketData?.qaPairs : emailData, tabSearch) : rows
         }
         pagination={{
           current: pageNo + 1, // Track the current page
           total: count, // Total number of records
           pageSize: 20,
           onChange: (page) => {
             // console.log("page", page);
             setPageNo(page - 1);
             // Fetch the data for the selected page here if needed
           },
         }}
        // pagination={tableParams.pagination}
         onChange={handleChange}
         style={{ boxShadow: "7px 7px 20px lightgrey" }}
        //  scroll={{
        //    y: 500,
        //  }}
         responsive
       />
       :
        <Table
       rowSelection={doctype.value !== "emailIntegration" &&rowSelection}
       columns={doctype.value === "Thread" ? ThreadColumns :doctype.value === "emailIntegration"&&qaPair ? QaPairColumn: columns}
       showSorterTooltip={false}
       dataSource={doctype.value==="emailIntegration"?filtering(qaPair?ticketData?.qaPairs:emailData, tabSearch):rows}
       rowKey={(record) => record}
       onChange={onChange}
       // pagination={false}
       pagination={tableParams.pagination}
       // className="mb-5"
       rowClassName={(record, index) =>
         index % 2 === 0 ? "table-row-light" : "table-row-dark"
       }
       style={{ boxShadow: "7px 7px 20px lightgrey", marginBottom:'12%' }}
     />
       }
    
     </Spin> */}
      <Spin spinning={isLoading}>
        {
          doctype.value === "emailIntegration" && !qaPair ? (
            <>
              {/* <h1>hello</h1> */}

              <Table
                columns={getColumns()}
                dataSource={getDataSource()}
                pagination={{
                  current: pageNo + 1, // Track the current page
                  total: count, // Total number of records
                  // pageSize: ['10','20','30'],
                  pageSize:"20",
                  onChange: (page) => {
                    // console.log("page", page);
                    setPageNo(page - 1);
                    // Fetch the data for the selected page here if needed
                  },
 
                }}
                onChange={handleChange}
                scroll={{y: 500}}
                responsive
              />

            </>
          ) : (
            <Table
              key={qaPair ? "qaPairTable" : doctype.value === "Thread" ? "threadTable" : "defaultTable"}
              rowSelection={doctype.value !== "emailIntegration" && rowSelection}
              columns={
                doctype.value === "Thread"
                  ? ThreadColumns
                  : doctype.value === "emailIntegration" && qaPair
                    ? QaPairColumn
                    : columns
              }
              showSorterTooltip={false}
              dataSource={
                doctype.value === "emailIntegration" && qaPair
                  ? filtering(qaPair ? ticketData?.qaPairs : emailData, tabSearch)
                  : rows
              }
              rowKey={(record) => record}
              onChange={onChange}
              pagination={tableParams.pagination}
              rowClassName={(record, index) =>
                index % 2 === 0 ? "table-row-light" : "table-row-dark"
              }
              style={{ boxShadow: "7px 7px 20px lightgrey", marginBottom: "12%" }}
            />
          )
        }
      </Spin>

    </div>
  );
}




